import * as z from "zod";

export enum GiftAuthStatus {
  AUTHENTICATED = "authenticated",
  ORDER_SELECTION_REQUIRED = "order_selection_required",
}

const authenticatedGiftAuthOutput = z.object({
  status: z.literal(GiftAuthStatus.AUTHENTICATED),
  customerAuthToken: z.string(),
  customer: z.object({ name: z.string(), email: z.string() }),
  orderId: z.string(),
});

const orderSelectionRequiredGiftAuthOutput = z.object({
  status: z.literal(GiftAuthStatus.ORDER_SELECTION_REQUIRED),
  orders: z.array(z.object({ shopifyId: z.string(), orderName: z.string() })),
});

export const giftAuth = {
  name: "giftAuth" as const,
  input: z.object({
    gifterEmail: z.string(),
    orderIdTrackingNumber: z.string(),
  }),
  output: z.discriminatedUnion("status", [
    authenticatedGiftAuthOutput,
    orderSelectionRequiredGiftAuthOutput,
  ]),
};
